import { createFileRoute, Navigate } from "@tanstack/react-router"

export const Route = createFileRoute("/_authenticated/_organization/finance/")({
  component: () => <Navigate to="/finance/overview" />,
})
